var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 16.6673C2.87484 16.6673 2.48248 16.5041 2.15609 16.1777C1.8297 15.8513 1.6665 15.459 1.6665 15.0007V5.00065C1.6665 4.54232 1.8297 4.14996 2.15609 3.82357C2.48248 3.49718 2.87484 3.33398 3.33317 3.33398H16.6665C17.1248 3.33398 17.5172 3.49718 17.8436 3.82357C18.17 4.14996 18.3332 4.54232 18.3332 5.00065V15.0007C18.3332 15.459 18.17 15.8513 17.8436 16.1777C17.5172 16.5041 17.1248 16.6673 16.6665 16.6673H3.33317ZM8.93984 10.1715C9.58838 10.5768 10.4113 10.5768 11.0598 10.1715L16.3344 6.8749C16.541 6.74577 16.6665 6.5193 16.6665 6.27565C16.6665 5.72061 16.056 5.38223 15.5853 5.6764L11.0598 8.50482C10.4113 8.91016 9.58838 8.91016 8.93984 8.50482L4.41437 5.6764C3.9437 5.38223 3.33317 5.72061 3.33317 6.27565C3.33317 6.5193 3.45869 6.74577 3.6653 6.8749L8.93984 10.1715Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.3d03d1235979164e0d91353eaf3d00a4.svg";
export { ForwardRef as ReactComponent };